var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('a',{staticClass:"tab",class:{ 'is-active': tab.isActive },attrs:{"href":tab.href},on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._v(_vm._s(tab.name))])}),0),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }